module.exports = __webpack_public_path__ + "img/SketchPng519f001b4215b4bbcf7e95a97d751f5dc43827db24a0c70e17865599222b9c09.6619ae50.png";